import React, { Component } from "react";
import FloatingActionButton from "material-ui/FloatingActionButton";
import ContentAdd from "material-ui/svg-icons/content/add";
import FontIcon from "material-ui/FontIcon";
import TableRowTrajets from "./TableRowTrajets";
import Loader from "../components/Loader";
import DialogWrapper from "../components/Dialog/DialogWrapper";
import { postTrajet } from './TableTrajets.util'

const classes = {
  headerIcons: {
    marginRight: 6
  }
}

export class TableTrajets extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      trajets: [],
      validators: [],
      openRequiredDialog: false,
      openSuccessDialog: false,
      openErrorDialog: false,
      disabledSendButton: "inline-block"
    };
  }

  componentDidMount = () => {
    const emptyTrajet = {
      id: Math.random(),
      dateTrajet: null,
      horaireTrajet: null,
      hours: "",
      minutes: "",
      distance: ""
    };

    this.setState({ trajets: [...this.state.trajets, emptyTrajet] });
  };

  handleCloseRequiredDialog = () =>
    this.setState({ openRequiredDialog: false });

  handleCloseSuccessDialog = () => this.setState({ openSuccessDialog: false });

  handleCloseErrorDialog = () => this.setState({ openErrorDialog: false });

  addRow = () => {
    const newTrajet = {
      id: Math.random(),
      dateTrajet: null,
      horaireTrajet: null,
      hours: "",
      minutes: "",
      distance: ""
    };

    this.setState({
      trajets: [...this.state.trajets, newTrajet],
      validators: [...this.state.validators, newTrajet],
      disabledSendButton: "inline-block"
    });

    JS.onClickLink(this, "ajouterTrajetOnDemandOnClick");
  };

  addTrajet = () => {
    this.state.trajets.map(trajet => {
      // Check Date and Horaire inputs
      if (trajet.dateTrajet && trajet.horaireTrajet) {
        let duree = "";

        // Check Hours and Minutes inputs
        if (!trajet.minutes.length && !trajet.hours.length) {
          this.setState({
            openRequiredDialog: true,
            validators: [...this.state.validators, trajet]
          });
        } else {
          if (trajet.minutes.length && trajet.hours.length) {
            duree = Math.floor(
              parseInt(trajet.hours) * 60 + parseInt(trajet.minutes)
            );
          } else if (!trajet.minutes.length && trajet.hours.length) {
            duree = Math.floor(parseInt(trajet.hours) * 60);
          } else if (trajet.minutes.length && !trajet.hours.length) {
            duree = parseInt(trajet.minutes);
          }

          // Check all trajets are good
          if (!this.state.validators.length) {
            this.setState({ isLoading: true });
            const { personId, policyId, productId } = this.props;

            // Create Sugar Task
            postTrajet(trajet, duree, productId, policyId, personId)
              .then(r => r.json())
              .then(data => {
                if (data.reference != null) {
                  this.setState({
                    isLoading: false,
                    openSuccessDialog: true,
                    trajets: [],
                    disabledSendButton: "none"
                  });
                } else {
                  this.setState({ isLoading: false, openErrorDialog: true })
                }
              })
              .catch(() => this.setState({ isLoading: false, openErrorDialog: true }));
          } else {
            this.setState({
              openRequiredDialog: true
            });
          }
        }
      } else {
        this.setState({
          openRequiredDialog: true,
          validators: [...this.state.validators, trajet]
        });
      }
    });
  };

  deleteTrajet = id => {

    this.state.validators.map(trajet => {
      if (trajet.id === id) {
        this.setState({
          validators: this.state.validators.filter(
            (_, i) => i !== this.state.validators.indexOf(trajet)
          )
        });
      }
    });

    this.state.trajets.map(stateTrajet => {
      if (stateTrajet.id === id) {
        this.setState(
          {
            trajets: this.state.trajets.filter(
              (_, i) => i !== this.state.trajets.indexOf(stateTrajet)
            )
          },
          () => {
            if (this.state.trajets.length === 0) {
              this.setState({ disabledSendButton: "none" });
            }
          }
        );
      }
    });
  };

  updateTrajet = (trajet) => {
    this.state.validators.map(currentTrajet => {
      if (currentTrajet.id === trajet.id) {
        this.setState({
          validators: this.state.validators.filter(
            (_, i) => i !== this.state.validators.indexOf(currentTrajet)
          )
        });
      }
    });

    const i = this.state.trajets.findIndex(t => t.id === trajet.id)
    const trajets = [...this.state.trajets];
    trajets.splice(i, 1, { ...this.state.trajets[i], ...trajet })
    this.setState({ trajets })
  };

  render() {
    return (
      <div>
        <div
          style={{
            margin: 30,
            color: "#FFF",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <FontIcon
              style={{ width: 24, marginRight: 6 }}
              className="material-icons"
              color="rgb(255, 186, 0)"
            >
              information
            </FontIcon>
            <h4>
              <strong>INFORMATION</strong>
            </h4>
          </div>
          <div className="container-infos-trajets">
            <strong style={{ color: "black" }}>
              En cas de problème avec votre téléphone, l'application ou le badge
              bluetooth, il est nécessaire de nous déclarer les prochains
              trajets que vous effectuerez.
            </strong>
          </div>
        </div>

        {!this.state.trajets.length ? (
          <div className="text-center">
            <strong style={{ color: "black", fontSize: "1.6em" }}>
              POUR COMMENCER, VEUILLEZ AJOUTER UN TRAJET
            </strong>
            <br /> <br />
            <FloatingActionButton
              onClick={this.addRow}
              backgroundColor="rgb(255, 186, 0)"
            >
              <ContentAdd />
            </FloatingActionButton>
          </div>
        ) : (
            <div className="main-page-guarantees">
              <div className="container">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="guarantees-table">
                      <table className="rwd-table">
                        <tr>
                          <th>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                              }}
                            >
                              <FontIcon className="material-icons" style={classes.headerIcons}>
                                date_range
                            </FontIcon>
                              <span style={{ textTransform: 'uppercase' }}>Date</span>
                            </div>
                          </th>
                          <th>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                              }}
                            >
                              <FontIcon className="material-icons" style={classes.headerIcons}>
                                alarm
                            </FontIcon>
                              <span>Horaire</span>
                            </div>
                          </th>
                          <th>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                              }}
                            >
                              <FontIcon className="material-icons" style={classes.headerIcons}>
                                history
                            </FontIcon>
                              <span>Durée estimée</span>
                            </div>
                          </th>
                          <th>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                              }}
                            >
                              <FontIcon className="material-icons" style={classes.headerIcons}>
                                map
                            </FontIcon>
                              <span style={{ width: "max-content" }}>Distance estimée</span>
                            </div>
                          </th>
                          <th />
                        </tr>
                        {this.state.trajets.map(trajet => (
                          <TableRowTrajets
                            key={trajet.id}
                            {...trajet}
                            onDeleteTrajet={this.deleteTrajet}
                            onUpdateTrajet={this.updateTrajet}
                          />
                        ))}
                      </table>
                    </div>
                    <div className="container-btn-add-trajet-row">
                      <FloatingActionButton
                        onClick={this.addRow}
                        backgroundColor="rgb(255, 186, 0)"
                      >
                        <ContentAdd />
                      </FloatingActionButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

        <div className="admin-dashboard-interaction">
          {this.state.isLoading ? (
            <Loader />
          ) : (
              <a
                style={{
                  display: this.state.disabledSendButton,
                  backgroundColor: "rgb(255, 186, 0)",
                  color: "white",
                  border: "none"
                }}
                className="btn clear-link"
                href="javascript:void(0);"
                onClick={this.addTrajet}
                title="Valider"
              >
                Valider
              </a>
            )}
        </div>
        <DialogWrapper
          title="Champs obligatoires"
          handleCloseDialog={this.handleCloseRequiredDialog}
          isOpen={this.state.openRequiredDialog}
          message="Merci de remplir tous les champs"
        />
        <DialogWrapper
          title="Succès"
          handleCloseDialog={this.handleCloseSuccessDialog}
          isOpen={this.state.openSuccessDialog}
          message="Vos trajets ont bien été enregistrés"
        />
        <DialogWrapper
          title="Erreur"
          handleCloseDialog={this.handleCloseErrorDialog}
          isOpen={this.state.openErrorDialog}
          message="Une erreur s'est produite"
        />
      </div>
    );
  }
}
